import React from 'react'
import HeroSection from '../../components/Herosection/HeroSection.jsx';
import './rulepage.scss';

const Rulepage = () => {
	return (
		<>
			<div className='main-wrapper rulepage-wrapper'>
				<HeroSection name={"REGELN & INFOS"} />
				<div className='section-wrapper'>
						<div className='inner-section-wrapper'>
							<h2>📜 Ingame Regeln - NEXARK Cluster <small className='small-info-2'>Updated: 24.03.2026</small></h2>
							<section>
								<h3>1️⃣ Allgemeines Verhalten</h3>
								<ul>
									<li><strong>Respekt ist Pflicht</strong>
										<ul>
											<li>Behandle andere Spieler:innen mit Respekt.</li>
											<li>Kein Mobbing, Rassismus, Sexismus oder toxisches Verhalten.</li>
											<li>Wir handeln mit einer <strong>0,0 Toleranz</strong> bei Verstößen.</li>
										</ul>
									</li>
									<li><strong>Fair Play</strong>
										<ul>
											<li>Kein Cheating, Exploiting oder Script-Nutzung.</li>
											<li>Kein Verkauf von Dinos durch Echtgeld. Das ist ein Spiel - kein Job.</li>
											<li>Wir handeln mit einer <strong>0,0 Toleranz</strong> bei Verstößen.</li>
											<li>Bei Verdacht: Sofort melden - keine Selbstjustiz.</li>
										</ul>
									</li>
									<li><strong>Admins sind keine Babysitter</strong>
										<ul>
											<li>Lies die Regeln.</li>
											<li>Unwissenheit schützt nicht vor Konsequenzen.</li>
										</ul>
									</li>
								</ul>
							</section>
							<section>
								<h3>2️⃣ Gameplay & Miteinander</h3>
								<ul>
									<li><strong>Jeder Spieler hat einen Tribe zu gründen</strong>
										<ul>
											<li>Auf jeder Karte, zu der ihr transferiert - muss derselbe Tribe mit dem selben Namen erstellt werden.</li>
											<li>Das hilft der Administration, besserer Zuordnung und es ist einfacher bei Problemen.</li>
										</ul>
									</li>
									<li><strong>Keine Spieler blockieren oder trollen</strong>
										<ul>
											<li>Z.B. Base zugebaut / durch Fundamente blockiert, Dinos eingesperrt, Respawn-Punkte blockiert etc.</li>
										</ul>
									</li>
									<li><strong>Dinos anderer Spieler sind tabu</strong>
										<ul>
											<li>Keine Carnivoren locken, oder in Basen anderer Spieler transportieren.</li>
										</ul>
									</li>
									<li><strong>Keine Basen auf Boss-Terminals, Höhleneingängen oder wichtigen Ressourcen-Spots</strong>
										<ul>
											<li>Temporäre Betten und Grabsteine sind in Höhlen erlaubt.</li>
											<li><strong>Explorer Notes, Artefakte und Höhleneingänge müssen IMMER zugänglich sein.</strong></li>
										</ul>
									</li>
									<li><strong>Bieberdämme & andere Lootdrops</strong>
										<ul>
											<li>Müssen immer vollständig geleert werden.</li>
										</ul>
									</li>
									<li><strong>Brüten & Züchten</strong>
										<ul>
											<li>Auf Paarung gestellte Dino's müssen vor dem Ausloggen auf nicht paaren gestellt werden.</li>
											<li>Damit keine ungewollten Nachkommen entstehen. Die dann schlüpfen oder gebährt werden.</li>
										</ul>
									</li>
									<li><strong>Streamer & deren Mates</strong>
										<ul>
											<li>Streamer und ihre Mates sind in Ruhe zu lassen.</li>
											<li><strong>Unaufgefordertes Verschenken</strong> von Dinos oder Items an Streamer ist <strong>untersagt</strong>. Nur auf <strong>ausdrückliche</strong> Anfrage des Streamers erlaubt.</li>
											<li>Lasst die Spieler <strong>ihren eigenen</strong> Fortschritt machen und greift nicht <strong>ungefragt</strong> ein.</li>
											<li>Das Admin-Team behält sich vor, bei Verstößen <strong>Konsequenzen</strong> zu ziehen, auch <strong>ohne</strong> vorherige <strong>Ankündigung</strong>.</li>
										</ul>
									</li>
								</ul>
							</section>
							<section>
								<h3>3️⃣ Bauen & Strukturen</h3>
								<ul>
									<li><strong>Basengröße sinnvoll halten</strong>
										<ul>
											<li>Baut so groß wie <strong>ihr denkt</strong> dass ihr Platz braucht. Die <strong>maximale Anzahl</strong> der Strukturen liegt bei <strong>8500</strong>.</li>
											<li>Wird das Limit durch <strong>Exploits oder Ähnlichem</strong> umgangen, behalten wir uns vor Strukturen <strong>ungewarnt abzureißen</strong>.</li>
										</ul>
									</li>
									<li><strong>1 Hauptbase (auf einer Map) + 1 Außenposten pro weitere Karte und Tribe erlaubt</strong>
										<ul>
											<li>Weitere nur nach Admin-Freigabe.</li>
											<li><strong>Außenposten</strong> auf anderen Karten, sollten eine Größe von <strong>10x10x5</strong> nicht überschreiten.</li>
											<li>Außenposten sollten als Lager und Spawn (nach Transfer) dienen.</li>
										</ul>
									</li>
									<li><strong>Maximale Anzahl an Dinos die frei in der Base stehen dürfen</strong>
										<ul>
											<li>Wir beschränken uns auf <strong>30 Dinos</strong> die frei stehen dürfen. Für z.B. passive Ressourcenproduktion.</li>
											<li>Dies gilt für alle Tribe-Mitglieder. Während der Zucht ist diese Regel inaktiv.</li>
											<li>Sollte eine dauerhafte Zucht <strong>ausgenutzt</strong> werden, um <strong>mehr als 30 Dinos</strong> zu halten, sind Konsequenzen zu erwarten.</li>
											<ul>
												<li>Also beschränkt euch auf <strong>maximal</strong> 2 Zuchten zur gleichen Zeit.</li>
											</ul>
											<li>Maximal <strong>3</strong> Gacha's <strong>pro</strong> Tribe!</li>
										</ul>
									</li>
									<li><strong>Nicht genutzte Gebäude müssen entfernt werden</strong>
										<ul>
											<li>Dino-Fallen und Käfige müssen nach Gebrauch abgebaut werden.</li>
											<li>Inaktive Tribes werden nach <strong>20 Tagen</strong> gelöscht.</li>
											<li>Vorherige Info via Discord oder Ingame-Mail.</li>
											<li>Ihr fahrt in den Urlaub oder seid aus gewissen Gründen ein paar Tage nicht da - kein Problem. Meldet euch zuvor bei uns!</li>
										</ul>
									</li>
									<li>Ressourcen-Sammel-Strukturen, in der Open World - müssen unverschlossen und für alle zugänglich sein. <strong>Beispiele:</strong>
										<ul>
											<li>Öl Pumpe</li>
											<li>Gas Sammler</li>
											<li>und Ähnliche..</li>
										</ul>
									</li>
								</ul>
							</section>
							<section>
								<h3>4️⃣ Cluster & Transfers</h3>
								<ul>
									<li><strong>Charakter-, Dino- & Item-Transfers sind erlaubt, aber nur über vorgesehene Terminals</strong>
										<ul>
											<li>Das heißt; Obelisken, Lootdrops und Transmitter.</li>
											<li>Kein Glitchen, kein Missbrauch der Transfer-Mechaniken.</li>
										</ul>
									</li>
									<li><strong>Respektiere andere Karten</strong>
										<ul>
											<li>Außenposten auf neuen Karten nur dort bauen, wo sie niemanden blockieren.</li>
										</ul>
									</li>
								</ul>
							</section>
							<section>
								<h3>5️⃣ Support & Meldungen</h3>
								<ul>
									<li><strong>Probleme? Bugs? Regelbruch?</strong>
										<ul>
											<li>Melde dich beim Admin-Team über Discord oder im Support-Kanal.</li>
											<li>Screenshots/Videobeweise helfen!</li>
										</ul>
									</li>
									<li><strong>Kein öffentliches Anprangern von Spielern oder Admins</strong>
										<ul>
											<li>Kritik? Ja. Drama? Nein.</li>
											<li>Immer respektvoll & direkt.</li>
										</ul>
									</li>
								</ul>
							</section>
							<section>
								<h3>6️⃣ Haftung & Bugs</h3>
								<ul>
									<li><strong>Verlust durch Bugs, Mods oder Updates kann nicht garantiert ersetzt werden</strong>
										<ul>
											<li>ARK (und seine Mods) sind nicht fehlerfrei.</li>
											<li>Wenn mal etwas verschwindet oder kaputtgeht, ist das Teil des Spiels.</li>
											<li>Wir bemühen uns um Hilfe - aber: <strong>Kein Anspruch auf Ersatz!</strong></li>
										</ul>
									</li>
								</ul>
							</section>
							<section>
								<h3>7️⃣ Konsequenzen bei Regelverstößen</h3>
								<ul>
									<li>Regelverstöße führen zu Verwarnung, Bann oder Tribe-Löschung - je nach Schwere.</li>
									<li>Das Admin-Team hat das letzte Wort.</li>
									<li>Wir behalten uns vor, Einstellungen und Werte anzupassen um die Spielbalance zu gewährleisten.</li>
									<li>Wir behalten uns vor, die Regeln nach Bedarf der Community anzupassen.</li>
								</ul>
							</section>
							<h3>✅ Danke fürs Einhalten der Regeln & viel Spaß beim Spielen!</h3>
						</div>
						<div className="inner-section-wrapper">
							<h2>📋 Cluster Philosophie</h2>
							<section>
								<h3>1️⃣ Warum erhöhen wir nicht das Wild-Dino-Level sondern bleiben auf den offiziellen Werten?</h3>
								<ul>
									<li><strong>Wir lieben die Nähe zum Vanilla Gameplay</strong>
										<ul>
											<li>Wild Dino Level hochschrauben, bedeutet man müsste alles andere auch anpassen.</li>
											<li>Ergo - macht das hochschrauben keinen Sinn, zumindest für uns.</li>
											<li>Noch würden wir es komisch finden, Dinos mit Level 2900 rumlaufen zu sehen.</li>
										</ul>
									</li>
								</ul>
							</section>
							<section>
								<h3>2️⃣ Warum habt ihr keine speziellen Dinos wie S-Dino Variants oder Shiny Dinos etc. ?</h3>
								<ul>
									<li><strong>Die einzigen Dinos die wirklich scheinen sollten, sind in unseren Augen - Aberrant Varianten</strong>
										<ul>
											<li>Zu viel abgespacet ist nicht unser Ding - auch wenn wir die Drakara's (Ikrane) haben.</li>
											<li>Die Ikrane erweitern das Spielerlebnis in der Luft. Was sehr gut in den Spielfluss passt.</li>
											<li>Desweiteren nutzen wir die Drachen aus der Dragons Kingdoms. Welche auch das Spielerlebnis in der Luft erweitern.</li>
										</ul>
									</li>
								</ul>
							</section>
							<section>
								<h3>3️⃣ Warum nutzt ihr keine Teleporter oder Teleporter Mods?</h3>
								<ul>
									<li><strong>Sie zerstören in unseren Augen einen wesentlichen Teil des Spiels</strong>
										<ul>
											<li>Teleporter Mods machen das Spielen zu leicht und reduzieren die Herausforderung.</li>
											<li>Bei uns kann Bewegungsgeschwindigkeit gelevelt werden, damit kommt man schnell über die Map.</li>
											<li>Man sollte aber nicht übertreiben mit der Bewegungsgeschwindigkeit. (BattlEye)</li>
										</ul>
									</li>
								</ul>
							</section>
							<section>
								<h3>4️⃣ Warum nutzt ihr die SCS (Super Cryo Storage) oder DinoDepot - Mod nicht?</h3>
								<ul>
									<li><strong>Ganz einfach erklärt, aus Performance- und Update-Gründen.</strong>
										<ul>
											<li>Die Vanilla CryoPods sind ausreichend genug, um dass zu tun was man damit tun muss.</li>
											<li>Desweiteren bietet CS (CybersStructures) ähnliche Funktionen mit CS eigenen CryoPods.</li>
											<li>Wie wir aus der Vergangenheit wissen, können Modifizierte CryoPods im Updatefall fatale Fehler mit sich bringen. - Das wollen wir vermeiden.</li>
										</ul>
									</li>
								</ul>
							</section>
							<h3>✅ Sollten weitere Fragen aufkommen die unsere Philosophie und unser Konzept untermauern, fügen wir diese hier ein!</h3>
						</div>
						{/* <div className='language-wrapper language-en'>
							<h2>📜 Ingame Rules - NEXARK Cluster</h2>
							<section>
								<h3>1️⃣ General Behavior</h3>
								<ul>
									<li><strong>Respect is mandatory</strong>
										<ul>
											<li>Treat other players with respect.</li>
											<li>No bullying, racism, sexism, or toxic behavior.</li>
										</ul>
									</li>
									<li><strong>Fair Play</strong>
										<ul>
											<li>No cheating, exploiting, or script use.</li>
											<li>If you suspect someone: report immediately – no vigilante justice.</li>
										</ul>
									</li>
									<li><strong>Admins are not babysitters</strong>
										<ul>
											<li>Read the rules.</li>
											<li>Not knowing the rules is no excuse.</li>
										</ul>
									</li>
								</ul>
							</section>
							<section>
								<h3>2️⃣ Gameplay & Interaction</h3>
								<ul>
									<li><strong>Each player must found a tribe.</strong>
										<ul>
											<li>This helps with administration, better allocation, and makes it easier to deal with problems.</li>
										</ul>
									</li>
									<li><strong>No blocking or trolling other players</strong>
										<ul>
											<li>e.g. blocking bases, trapping dinos, blocking spawn points, etc.</li>
										</ul>
									</li>
									<li><strong>Other players' dinos are off-limits</strong>
										<ul>
											<li>No killing, luring, or dragging away – regardless of tame or passive status.</li>
										</ul>
									</li>
									<li><strong>No bases at boss terminals, cave entrances, or major resource spots</strong>
										<ul>
											<li>Temporary beds and gravestones are allowed in caves.</li>
											<li><strong>Explorer Notes must ALWAYS remain accessible.</strong></li>
										</ul>
									</li>
								</ul>
							</section>
							<section>
								<h3>3️⃣ Building & Structures</h3>
								<ul>
									<li>
										<strong>Keep base size reasonable</strong>
										<ul>
											<li>Build as big as you think you'll need space for. The maximum number of structures is 10500.</li>
										</ul>
									</li>
									<li><strong>1 main base (on one map) + 1 outpost per additional map and tribe allowed</strong>
										<ul>
											<li>Additional structures only with admin approval.</li>
										</ul>
									</li>
									<li><strong>Unused buildings must be removed</strong>
										<ul>
											<li>Inactive tribes will be deleted after <strong>20 days</strong>.</li>
											<li>Notice will be given via Discord or in-game mail.</li>
											<li>You're going on vacation or will be away for a few days for some reason - no problem.</li>
										</ul>
									</li>
								</ul>
							</section>
							<section>
								<h3>4️⃣ Cluster & Transfers</h3>
								<ul>
									<li><strong>Character, dino & item transfers are allowed, but only via designated terminals</strong>
										<ul>
											<li>No glitching or abuse of transfer mechanics.</li>
										</ul>
									</li>
									<li><strong>Respect other maps</strong>
										<ul>
											<li>Only build bases in areas that don't block others.</li>
											<li>Destruction on the <strong>rotation map</strong> is to be expected.</li>
										</ul>
									</li>
								</ul>
							</section>
							<section>
								<h3>5️⃣ Support & Reports</h3>
								<ul>
									<li><strong>Problems? Bugs? Rule violations?</strong>
										<ul>
											<li>Contact the admin team via Discord or the support channel.</li>
											<li>Screenshots or videos are very helpful!</li>
										</ul>
									</li>
									<li><strong>No public shaming of players or admins</strong>
										<ul>
											<li>Criticism? Yes. Drama? No.</li>
											<li>Always respectful & direct.</li>
										</ul>
									</li>
								</ul>
							</section>
							<section>
								<h3>6️⃣ Liability & Bugs</h3>
								<ul>
									<li><strong>Loss due to bugs, mods, or updates cannot be guaranteed for replacement</strong>
										<ul>
											<li>ARK (and its mods) are not perfect.</li>
											<li>If something disappears or breaks, it’s part of the game.</li>
											<li>We will try to help – but there’s <strong>no entitlement to compensation</strong>.</li>
										</ul>
									</li>
								</ul>
							</section>
							<section>
								<h3>7️⃣ Rule Violations & Consequences</h3>
								<ul>
									<li>Breaking the rules may result in a warning, ban, or tribe deletion – depending on severity.</li>
									<li>The admin team has the final say.</li>
									<li>We reserve the right to adapt rules based on community needs.</li>
								</ul>
							</section>
							<h3>✅ Thanks for following the rules – and have fun playing!</h3>
						</div> */}
				</div>
			</div>
		</>
	)
}

export default Rulepage